import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GameCard = ({ 
  game, 
  onStartGame, 
  className = "" 
}) => {
  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'easy': return 'text-success bg-success/10';
      case 'medium': return 'text-warning bg-warning/10';
      case 'hard': return 'text-error bg-error/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getIconColor = (type) => {
    switch (type) {
      case 'reaction': return 'var(--color-primary)';
      case 'memory': return 'var(--color-accent)';
      case 'attention': return 'var(--color-warning)';
      default: return 'var(--color-muted-foreground)';
    }
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-6 hover:shadow-soft-md transition-all duration-200 ${className}`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center">
            <Icon 
              name={game?.icon} 
              size={24} 
              color={getIconColor(game?.type)}
            />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{game?.name}</h3>
            <div className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${getDifficultyColor(game?.difficulty)}`}>
              {game?.difficulty}
            </div>
          </div>
        </div>
        
        {game?.personalBest && (
          <div className="text-right">
            <div className="text-xs text-muted-foreground">Personal Best</div>
            <div className="text-sm font-semibold text-foreground">{game?.personalBest}</div>
          </div>
        )}
      </div>
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
        {game?.description}
      </p>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={14} />
            <span>{game?.duration}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Target" size={14} />
            <span>{game?.attempts} attempts</span>
          </div>
        </div>
      </div>
      <Button
        variant="default"
        onClick={() => onStartGame(game)}
        className="w-full"
        iconName="Play"
        iconPosition="left"
      >
        Start Game
      </Button>
    </div>
  );
};

export default GameCard;